/**
 * Get the value of a querystring
 * @param  {String} field The field to get the value of
 * @param  {String} url   The URL to get the value from (optional)
 * @return {String}       The field value
 */
const getQueryString = (field, url) => {
  let href = window.location.href
  let reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i')
  let string = reg.exec(href)
  return string ? string[1] : null
}

export {
  getQueryString
}



// WEBPACK FOOTER //
// ./src/services/getParameter.js